
import { Component, Input, OnInit, SimpleChanges, Output, EventEmitter } from "@angular/core";
import { AppMainComponent } from "src/app/app.main.component";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { Status } from "../../models/status";
import { AccountsTransactionType, Channel } from "src/app/finance/constants/constants";
import { ImportserialService } from "../../services/importserial.service";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";

@Component({
    selector: "app-item-receipt-view",
    templateUrl: "./item-receipt-view.component.html",
    styleUrls: ["./item-receipt-view.component.scss"],
})
export class ItemReceiptViewComponent implements OnInit {
    @Input() visibleFromModule;
    @Input() rpoDetail;
    @Input() isView : boolean = true;
    @Output() updateJournalList =new EventEmitter<boolean>();
    @Output() closeJournalList =new EventEmitter<boolean>();
    @Output() openScanInfoChild = new EventEmitter;
    length: number = 0;
    qtyDecimal: number = 0;
    baseCurrency: any;
    orgCurrency = [];
    selectedChannel: any =null;
    ordersVendorAddr = "";
    ordersVendorCity = "";
    ordersVendorState = "";
    ordersVendorCountry = "";
    ordersVendorZipcode = "";
    ordersVendorPhone;
    ordersVendorAddrNew = "";
    ordersVendorCityNew = "";
    ordersVendorStateNew = "";
    ordersVendorCountryNew = "";
    ordersVendorZipcodeNew = "";
    ordersVendorPhoneNew;
    purchase_billing: any[] = [];
    purchase_shipping: any[] = []; 
    purchase_misc: any[] = [];
    purchase_section: any[] = [];
    purchase_table: any[] = [];
    purchase_footer: any[] = [];
    purchase_message: any[] = [];
    purchase_other1: any[] = [];
    purchase_other2: any[] = [];
    purchase_other3: any[] = [];
    checkWithoutBill;
    subTotal: number = 0;
    memo;
    shippingAmount: number = 0;
    tax: number = 0;
    orderTotal: number = 0;
    discount: number = 0;
    lineTotal: number = 0;
    footerTaxEnabled: boolean = false;
    allLocationsDD;
    allLocations;
    receivePurchaseListTB = [];
    isFullyReceived: boolean = false;
    shipAddress;
    taxEnabled;
    allTax = [];
    poTemplate = null;
    purchaseListTB = [];
    transactionTypeIds = AccountsTransactionType;
    glApiCall: boolean = false;
    itemReceiptId: number;
    isAllowPostingPeriod: boolean = false;
    constructor(public app: AppMainComponent,private purchaseService: PurchasesService,private importService: ImportserialService,private utilityService: UtilityService) { }

    ngOnInit(): void {
        this.importService.getDecimalValue().subscribe(value => {
            if(value){
              this.length = value;
            }
        })
        this.importService.getQtyDecimalValue().subscribe(value => {
            if (value) {
              this.qtyDecimal = value;
            }
          })
          this.importService.getOrgCurrency().subscribe(value=>{
            if(value){
              this.baseCurrency = value.find(cr=> cr.isBaseCurrency);
              this.orgCurrency = value;
              if(!this.poTemplate){
                this.getPOSettings();
              }
            }
          })
        this.getAllTax();
        this.getAllLocations();
        this.getIsettings();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.rpoDetail?.currentValue) {
            this.itemReceiptId = this.rpoDetail.id;
            this.rpoDetail = changes.rpoDetail.currentValue;
            this.parseRPODetails();
        }
    }

    parseRPODetails() {
        this.selectedChannel = {id: this.rpoDetail.templateId};
        this.allLocationsDD = this.allLocations?.filter(
            (loc) => loc.statusId == Status.Active
        );
        if(this.rpoDetail.configJson){
            this.poTemplate = JSON.parse(this.rpoDetail.configJson);
            this.footerTaxEnabled = !this.poTemplate?.labels_table[9]?.isChecked && this.poTemplate?.labels_footer[4]?.isChecked;
        }
        this.checkWithoutBill = !this.rpoDetail.isBillCreated;
        this.rpoDetail.postingDate = this.rpoDetail?.postingDate ? this.app._showDateTimeWithZone(this.rpoDetail?.postingDate) : null;
        this.subTotal = Number(this.rpoDetail.totalAmount) * Number(this.rpoDetail?.exchangeRate);
        this.memo =
            this.rpoDetail.receivedPurchaseOrderNotes &&
                this.rpoDetail.receivedPurchaseOrderNotes.length > 0
                ? this.rpoDetail.receivedPurchaseOrderNotes[this.rpoDetail.receivedPurchaseOrderNotes?.length-1].note.comment
                : "";
        this.shippingAmount = Number(this.rpoDetail?.shippingChargeAmount) * Number(this.rpoDetail?.exchangeRate);
        this.tax = Number(this.rpoDetail.taxAmount) * Number(this.rpoDetail?.exchangeRate);
        this.orderTotal = Number(this.rpoDetail.netAmount) * Number(this.rpoDetail?.exchangeRate);
        this.discount = Number(this.rpoDetail.discountAmount)  * Number(this.rpoDetail?.exchangeRate);
        const filteredLocation = this.allLocationsDD?.find(l => l.id === this.rpoDetail?.warehouseId);
        this.getShipAddress(filteredLocation, true);
        this.receivePurchaseListTB = [];
        if (this.rpoDetail.receivedPurchaseOrderProducts.length > 0) {
            for (let l of this.rpoDetail.receivedPurchaseOrderProducts) {
                const bundleProducts: any[] = [];
                if (l.receivedPurchaseBundleDetail?.length > 0) {
                    for (let prd of l.receivedPurchaseBundleDetail) {
                        let eachProduct = {
                            id: prd.id,
                            productId: prd.productId,
                            subProductId: prd.subProductId,
                            receivedPurchaseOrderProductId:
                                prd.receivedPurchaseOrderProductId,
                            receivedPurchaseOrderId: l.receivedPurchaseOrderId,
                            itemNo: prd.product?.itemNo,
                            typeId: prd.products?.typeId,
                            description: prd.product?.description,
                            quantity: prd.orderedQty,
                            quantityReceived: prd.qtyReceived,
                            originalQtyPending: prd.qtyPending,
                            quantityPending: prd.qtyPending,
                            currentVal: prd.orderedQty,
                            unit: prd.productUnitId,
                            uom: prd.product?.productUOM.find(uom => uom.unitOfMeasureId === prd.productUnitId)?.uomDetail?.name,
                            cost: parseFloat(prd.totalAmount).toFixed(this.length),
                            pricePerProduct: parseFloat(
                                prd.pricePerProduct
                            ).toFixed(this.length),
                            isClosed: prd.isClosed,
                            receivedProductStatus: prd.receivedProductStatus,
                            tax: prd.tax?.name,
                            taxId: prd.taxId,
                            taxRate: prd.taxRate,
                            taxTypeId: prd.taxTypeId,
                            taxFinancialId: prd.taxFinancialId,
                            taxName: prd.taxName,
                            discountAmount: prd.discountAmount,
                            discountType: prd.discountType?.description,
                            discountTypeId: prd.discountTypeId,
                            discountFinancialId: prd.discountFinancialId,
                            discountId: prd.discountId,
                            discountName: prd.discountName,
                            trackingEnabled: prd.product?.isTrackingRequired,
                            serialSettings: prd.product?.serialSettings
                                ? JSON.parse(prd.product?.serialSettings)
                                : null,
                            receivedPurchaseOrderBundleSerialDetail:
                                prd.receivedPurchaseOrderBundleSerialDetail,
                            serialCount: prd.serialCount
                        };
                        bundleProducts.push(eachProduct);
                    }
                }
                let eachProduct = {
                    id: l.id,
                    productId: l.productId,
                    itemNo: l.product?.itemNo,
                    receivedPurchaseOrderId: l.receivedPurchaseOrderId,
                    description: l?.description,
                    uom: l.product?.productUOM?.find(uom => uom.unitOfMeasureId === l.productUnitId)?.uomDetail?.name,
                    unit: l.productUnitId,
                    warehouseId: l.warehouseId,
                    quantity: l.orderedQty,
                    quantityReceived: l.qtyReceived,
                    quantityPending: l.qtyPending,
                    pricePerProduct: (Number(l.pricePerProduct) * Number(this.rpoDetail?.exchangeRate)).toFixed(this.length),
                    cost: Number(l.totalAmount) * Number(this.rpoDetail?.exchangeRate),
                    netAmount: Number(l.netAmount) * Number(this.rpoDetail?.exchangeRate),
                    isClosed: l.isClosed,
                    receivedProductStatus: l.receivedProductStatus,
                    tax: l.tax?.name,
                    taxId: l.taxId,
                    taxRate: l.taxRate,
                    taxTypeId: l.taxTypeId,
                    taxFinancialId: l.taxFinancialId,
                    taxName: l.taxName,
                    taxAmount: l.receivedPOProductSubTax?.reduce((sum, s) => sum + (Number(s.taxAmount) * this.rpoDetail?.exchangeRate), 0).toFixed(this.length),
                    discountAmount: l.discountAmount,
                    discountType: l.discountType?.description,
                    discountTypeId: l.discountTypeId,
                    discountFinancialId: l.discountFinancialId,
                    discountId: l.discountId,
                    discountName: l.discountName,
                    typeId: l.products?.typeId,
                    trackingEnabled: l.product?.isTrackingRequired,
                    serialSettings: l.product?.serialSettings
                        ? JSON.parse(l.product?.serialSettings)
                        : null,
                    ReceivedPurchaseOrderSerialDetail:
                        l.receivedPurchaseOrderSerialDetail,
                    serialCount: l.serialCount,
                    products: bundleProducts,
                };
                this.receivePurchaseListTB.push(eachProduct);
            }
        }
        this.lineTotal= this.receivePurchaseListTB?.reduce((sum, s) => sum + (Number(s.netAmount) * this.rpoDetail?.exchangeRate), 0);
        this.isFullyReceived = true;
    }

    getShipAddress(location, action?) {
        this.shipAddress = location;
        if (!action) {
            // this.panel.hide();
        }
    }

    getAllTax() {
        this.purchaseService.getAllTax().subscribe((res) => {
            this.taxEnabled = res.item1;
            if (res.item1) {
                this.allTax = res.item2;
            }
        });
    }

    getAllLocations() {
        this.purchaseService.getAllLocations().subscribe((locations) => {
            for (let loc of locations) {
                loc.customName = loc.name + " - " + loc.locationId;
            }
            this.allLocations = locations;
        });
    }

    getPOSettings() {
        this.purchaseService.getPOConfigurations('Purchase')
            .subscribe((configs) => {
                const purchaseTemplate = configs?.find(config => config.name == 'Purchase Template');
                if (purchaseTemplate?.configurationDetails.length > 0) {
                    const allPurchaseTemplates = JSON.parse(purchaseTemplate?.configurationDetails[0].configJSONValue);
                    this.poTemplate = allPurchaseTemplates?.find((t) => t.producttypeId == Channel.ItemReceipt);
                    this.footerTaxEnabled = !this.poTemplate?.labels_table[9]?.isChecked && this.poTemplate?.labels_footer[4]?.isChecked;
                }
            });
    }

    updateJournal(e){
        this.updateJournalList.emit(e);
    }

    closeJournal(){
        this.closeJournalList.emit();
    }

    openScanInfo(e, type) {
        if(e.serialCount>0){
          e.type = type;
          e.rpoId = this.rpoDetail?.id;
          this.openScanInfoChild.emit(e);
        }
      }

    onTabChange(event){
        if(event.index == 1){
            this.glApiCall = true;
        }
        else{
            this.glApiCall = false;
        }
    }
    getIsettings(){
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find((obj) => obj.code === "posting")?.enabled ?? false;
      }
}
